export { Faq } from './faq'
